import React, {useState, useEffect} from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

interface CounterProps {
    type: "power" | "letter" | "watt";
    start: number | string;
    end: number | string;
    unit?: string;
    upperText?: string;
}

const Counter_holly: React.FC<CounterProps> = ({type, start, end, unit, upperText}) => {
    const [currentValue, setCurrentValue] = useState<string | number>(start);

    useEffect(() => {
        if (type === 'letter' && typeof end === 'string') { // Ensure end is treated as a string
            // Start with a random three-letter string
            let randomLetters = 'RAEDAZZXTC';
            setCurrentValue(randomLetters);
            let letters = randomLetters.split('');

            const intervalId = setInterval(() => {
                letters = letters.map((currentLetter, index) => {
                    const targetLetter = end[index]; // Access end as a string
                    // Gradually change each letter to the target 'LEO'
                    if (currentLetter !== targetLetter) {
                        return nextLetter(currentLetter, targetLetter);
                    }
                    return currentLetter;
                });

                setCurrentValue(letters.join(''));

                // Stop the interval when all letters match 'LEO'
                if (letters.join('') === end) {
                    clearInterval(intervalId);
                }
            }, 50);
        }


        if (type === 'watt' && typeof end === 'string') { // Ensure end is treated as a string
            // Start with a random three-letter string
            let randomLetters = 'RAEDAZZG';
            setCurrentValue(randomLetters);
            let letters = randomLetters.split('');

            const intervalId = setInterval(() => {
                letters = letters.map((currentLetter, index) => {
                    const targetLetter = end[index] // Access end as a string
                    // Gradually change each letter to the target 'LEO'
                    if (currentLetter !== targetLetter) {
                        return nextLetter(currentLetter, targetLetter);
                    }
                    return currentLetter;
                });

                setCurrentValue(letters.join(''));

                // Stop the interval when all letters match 'LEO'
                if (letters.join('') === end) {
                    clearInterval(intervalId);
                }
            }, 50);
        }


    }, [type, end]);

    


    const generateRandomLetters = () => {
        const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        return Array.from({length: 3}, () => possible.charAt(Math.floor(Math.random() * possible.length))).join('');
    };

    const nextLetter = (currentLetter: string, targetLetter: string) => {
        const currentCharCode = currentLetter.charCodeAt(0);
        const targetCharCode = targetLetter.charCodeAt(0);
        const nextCharCode = currentCharCode < targetCharCode ? currentCharCode + 1 : currentCharCode - 1;
        return String.fromCharCode(nextCharCode);
    };

    return (
        <div className="text-center p-4">

            <div className="text-xl pb-4">{type === 'power' ? 'UP TO' : type === 'watt' ? 'INCLUDES A' : 'REDUNDANT'}</div>

            {type === 'letter'||type==='watt'  ? (
                <div className="text-4xl md:text-4xl font-bold">{currentValue}</div>
                ) : (
                <CountUp start={parseFloat(start.toString())} end={parseFloat(end.toString())} duration={2.5}
                         redraw={true}>
                    {({countUpRef, start}) => (
                        <VisibilitySensor onChange={start} delayedCall>
                            <div>
                                <span ref={countUpRef} className="text-4xl md:text-5xl font-bold text-center">
                            {currentValue}


                            </span>
                                <span className="text-4xl md:text-4xl font-bold text-center uppercase">{unit}</span>
                            </div>
                        </VisibilitySensor>

                    )}

                </CountUp>
                    )}
            <div className="text-xl uppercase  pt-4 ">
                {type === 'power'
                    ? <>reduction in<br />
                    deployment shock</>
                    : type === 'watt'
                        ? <>system</>
                        : <>MECHANISM</>}
            </div>
        </div>
    );
};

export default Counter_holly;
